import { render, staticRenderFns } from "./PieChart.vue?vue&type=template&id=36c457f2"
import script from "./PieChart.vue?vue&type=script&lang=js"
export * from "./PieChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-producerPlatform-fe/treasurenet-tnservices-producerPlatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36c457f2')) {
      api.createRecord('36c457f2', component.options)
    } else {
      api.reload('36c457f2', component.options)
    }
    module.hot.accept("./PieChart.vue?vue&type=template&id=36c457f2", function () {
      api.rerender('36c457f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/PieChart.vue"
export default component.exports